import { Card, Accordion } from 'react-bootstrap'
import { GroupSelect } from 'GroupSelect'
import { useSettings } from 'Settings'

const type_options = [
	{ value: "MAX", label : "MAX" },
	{ value: "TYP", label : "TYP" },
	{ value: "MIN", label : "MIN" },
]

const voltage_options = {
	"MAX" : [
		{ value : 1.32, label : 1.32 },
		{ value : 1.705, label : 1.705 },
		{ value : 1.815, label : 1.815 },
		{ value : 1.98, label : 1.98 },
		{ value : 2.2, label : 2.2 },
		{ value : 2.42, label : 2.42 },
		{ value : 2.64, label : 2.64 },
		{ value : 2.86, label : 2.86 }
	],
	"TYP" : [
		{ value : 1.2, label: 1.2 },
		{ value : 1.55, label: 1.55 },
		{ value : 1.65, label: 1.65 },
		{ value : 1.8, label: 1.8 },
		{ value : 2, label: 2 },
		{ value : 2.2, label: 2.2 },
		{ value : 2.4, label: 2.4 },
		{ value : 2.6, label: 2.6 },
	],
	"MIN" : [
		{ value : 1.08, label : 1.08 },
		{ value : 1.395, label : 1.395 },
		{ value : 1.485, label : 1.485 },
		{ value : 1.62, label : 1.62 },
		{ value : 1.8, label : 1.8 },
		{ value : 1.98, label : 1.98 },
		{ value : 2.16, label : 2.16 },
		{ value : 2.34, label : 2.34 }
	],
}

const LDOLevels = (prop) => {
	const [settings] = useSettings()
	const ll = settings['ldo levels']

	const updateAcc = (v, select, acc) => {
		const i = voltage_options[ll[acc].value].findIndex(
			({value}) => value === ll[select].value
		)

		ll[acc].setValue(v.value)
		ll[select].setValue(voltage_options[v.value][i].value)
	}

	return (
		<Card className="mb-3">
			<Card.Header>LDO Levels</Card.Header>
			<Card.Body>
				<Accordion>
					<Accordion.Item eventKey="0">
						<Accordion.Header>ULP LDO</Accordion.Header>
						<Accordion.Body>
							<GroupSelect
								options={voltage_options[ll['v_ulp_ldo_acc'].value]}
								name="v_ulp_ldo"
								unit="V"
								value={ll['v_ulp_ldo'].value}
								onChange={(v) => ll['v_ulp_ldo'].setValue(v.value)}
							/>
							<GroupSelect
								options={type_options}
								defaultValue={type_options[1]}
								name="v_ulp_ldo_acc"
								value={ll['v_ulp_ldo_acc'].value}
								onChange={(v) => updateAcc(v, 'v_ulp_ldo', 'v_ulp_ldo_acc')}
							/>
						</Accordion.Body>
					</Accordion.Item>
					<Accordion.Item eventKey="1">
						<Accordion.Header>AUX LDO</Accordion.Header>
						<Accordion.Body>
							<GroupSelect
								options={voltage_options[ll['v_aux_ldo_acc'].value]}
								name="v_aux_ldo"
								unit="V"
								value={ll['v_aux_ldo'].value}
								onChange={(v) => ll['v_aux_ldo'].setValue(v.value)}
							/>
							<GroupSelect
								options={type_options}
								defaultValue={type_options[1]}
								name="v_aux_ldo_acc"
								value={ll['v_aux_ldo_acc'].value}
								onChange={(v) => updateAcc(v, 'v_aux_ldo', 'v_aux_ldo_acc')}
							/>
						</Accordion.Body>
					</Accordion.Item>
				</Accordion>
			</Card.Body>
		</Card>
	)
}

export default LDOLevels
